import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore as createReduxStore,
  Middleware,
  Store,
  StoreEnhancer,
} from "redux";
import thunk from "redux-thunk";

import createSagaMiddleware from "redux-saga";
import { connectRoutes } from "redux-first-router";

import { ROUTING_CONFIG, SHARED_ROUTING_CONFIG } from "../appConfig/defaultConfig";

import { createReducer, RootState } from "./reducers";
import { reducerRegistry } from "./reducerRegistry";
import rootSaga from "./rootSaga";
import { createReduxRouter } from "./reduxRouter";
import { api } from "../evergis/api";

type CreateStoreParams = {
  initialState: Partial<RootState>;
  router: ReturnType<typeof connectRoutes>;
};

export function createStore({ initialState = {}, router }: CreateStoreParams): Store<RootState> {
  const sagaMiddleware = createSagaMiddleware();
  const devtoolsCompose =
    process.env.NODE_ENV !== "production" && typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const composeEnhancers = devtoolsCompose ? devtoolsCompose({ trace: true, traceLimit: 50 }) : compose;
  const middlewares: Middleware[] = [router.middleware, thunk, sagaMiddleware].filter(Boolean);
  const enhancers: StoreEnhancer[] = [router.enhancer, applyMiddleware(...middlewares)].filter(Boolean);
  const locationReducers = { location: router.reducer, ...reducerRegistry.getReducers() };

  const newStore = createReduxStore<RootState, AnyAction, Record<string, unknown>, Record<string, unknown>>(
    createReducer(locationReducers),
    initialState as never,
    composeEnhancers(...enhancers),
  );

  reducerRegistry.subscribe(reducers => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    newStore.replaceReducer(createReducer({ location: router.reducer, ...reducers }));
  });

  sagaMiddleware.run(rootSaga);

  return newStore;
}

export const store = createStore({
  initialState: {},
  router: createReduxRouter(api.isShared ? SHARED_ROUTING_CONFIG : ROUTING_CONFIG),
});
